import gql from 'graphql-tag';


import { JobOverview, JobInvoiceableInbox } from './jobInvoiceInbox';
import { querySelector } from '../../../utils';


export const JobUnreview = gql`
  mutation JobUnreview($input: JobUnreviewInput!) {
    job_unreview(input: $input) {
      ...JobOverview
    }
  }
  ${JobOverview}
`;


export const jobUnreviewApi = async (client, jobId, reason) => {
  const variables = {
    input: {
      id: jobId,
      unreview_reason: reason,
    },
  };

  const options = {
    mutation: JobUnreview,
    variables,
    refetchQueries: [
      { query: JobInvoiceableInbox },
    ],
  };

  /*
  * Read old invoiceable jobs from cache before calling server mutation. Many clients to this
  * function are concerned with the state of the collection during the update process.
  * TODO: How to deduplicate query selector? Its is copied straight from jobInvoiceInbox
   */
  const cachedQueryResults = client.readQuery({ query: JobInvoiceableInbox });
  const oldCollection = querySelector(cachedQueryResults, '$.jobs_for_approval_inbox.edges[*].node', []);
  const result = await client.mutate(options);

  return {
    oldCollection,
    result,
  };
};


export default jobUnreviewApi;
